export default __webpack_public_path__ + "static/media/C229251.92d24e7c.jpg";